import React from 'react'

import { BankIcon } from '@/assets/images/icons/bank'
import { CreditCardIcon } from '@/assets/images/icons/credit-card'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'

import { PaymentMethodType } from './PaymentMethods.types'

interface PaymentMethodTabsProps {
	selectedType: PaymentMethodType
	onTypeChange: (type: PaymentMethodType) => void
	showManualPayment?: boolean
	showAutomaticPayment: boolean
}

export const PaymentMethodTabs: React.FC<PaymentMethodTabsProps> = ({
	selectedType,
	onTypeChange,
	showManualPayment = true,
	showAutomaticPayment,
}) => {
	const { t } = useTranslation('common')
	const getTabClassName = (isActive: boolean) => {
		const baseClasses =
			'flex flex-col items-start justify-center w-[200px] h-[82px] rounded-lg border transition-colors'
		const activeClasses =
			'bg-muted border-border text-foreground dark:bg-card dark:border-white dark:text-white'
		const inactiveClasses =
			'bg-background border-border text-muted-foreground hover:bg-muted dark:bg-muted dark:border-border dark:text-muted-foreground'

		return `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`
	}

	const getIconClassName = (isActive: boolean) => {
		return isActive
			? 'dark:text-white text-foreground'
			: 'text-muted-foreground'
	}

	return (
		<div className="flex gap-4 mb-8">
			{showManualPayment && (
				<Button
					type="button"
					variant="outline"
					onClick={() => onTypeChange('bank')}
					className={getTabClassName(selectedType === 'bank')}
				>
					<div className={getIconClassName(selectedType === 'bank')}>
						<BankIcon color="currentColor" width={24} height={24} />
					</div>
					<span className="font-medium text-base">
						{t('payment_method.manual_payment')}
					</span>
				</Button>
			)}
			{showAutomaticPayment && (
				<Button
					type="button"
					variant="outline"
					onClick={() => onTypeChange('card')}
					className={getTabClassName(selectedType === 'card')}
				>
					<div className={getIconClassName(selectedType === 'card')}>
						<CreditCardIcon color="currentColor" width={24} height={24} />
					</div>
					<span className="font-medium text-base">
						{t('payment_method.automatic_payment')}
					</span>
				</Button>
			)}
		</div>
	)
}
